import { createApp, ref, onMounted, onUnmounted, nextTick } from 'vue';
import $ from 'jquery';

import { createPinia, storeToRefs } from 'pinia';
import useMiniCartStore from '@global/stores/useMiniCartStore';

import useHeaderDiffer from '@composable/useHeaderDiffer';
import useScrollBar from '@composable/useScrollBar';
import useGoToTop from '@global/composable/useGoToTop';
import useAlert from '@global/composable/useAlert';
import useMsg from '@global/composable/useMessage';
import useAxiosAPI from '@global/composable/api/useAxiosAPI';
import useModalStore from '@global/stores/useModalStore';

import NewImage from '@global/components/common/Image/NewImage.vue';
import AlertDialog from '@global/components/common/alert/AlertDialog.vue';
import Message from '@global/components/common/message/Message.vue';
import Modal from '@global/components/common/modal/Modal.vue';

import BrandBtn from '@components/BrandBtn.vue';

import BrandList from '@page/brand/components/BrandListMB.vue';
import globalCtrl from '@page/common/js/globalCtrl';

import layout from '@/style/layout.scss';

const pinia = createPinia();
const { alertDialog } = useAlert();
const { messageBox } = useMsg();
const { getBrandFollowAPI } = useAxiosAPI();

global.$ = require('jquery');

global.jQuery = global.$;

globalCtrl();

/**
 * popup、alert跳窗
 */
// eslint-disable-next-line vue/one-component-per-file
const appAlert = createApp({
  components: {
    AlertDialog,
    Message,
  },
});
appAlert.mount('#app-common');

/**
 * 桌機選單
 */

// eslint-disable-next-line vue/one-component-per-file
const pcHeader = createApp({
  components: {
    NewImage,
    Modal,
  },
  setup() {
    const { isActive, paddingStyle, useHeaderExtend, useResizeList, useControlHeader } =
      useHeaderDiffer();

    const isLogin = ref(false);

    const miniCartStore = useMiniCartStore();
    const { totalCount, count } = storeToRefs(miniCartStore);
    const { getCartInfo } = miniCartStore;
    const modalStore = useModalStore();
    const { isShow, modalName } = storeToRefs(modalStore);

    getCartInfo();

    function handleZeroQuantity() {
      alertDialog.alert('購物車目前無商品');
    }

    onMounted(() => {
      isLogin.value = window.IsLogin === 'True';

      window.addEventListener('scroll', useHeaderExtend);
      window.addEventListener('resize', useHeaderExtend, useResizeList);
      useHeaderExtend();
      useResizeList();
      useControlHeader();

      nextTick(() => {
        const bannderHight = $('header.header').outerHeight(true);
        $('#home-content .main-banner-container').css('padding-top', `${bannderHight}px`);
      });
    });

    onUnmounted(() => {
      window.removeEventListener('scroll', useHeaderExtend);
      window.removeEventListener('resize', useHeaderExtend);
    });
    return {
      isLogin,
      totalCount,
      handleZeroQuantity,
      isActive,
      paddingStyle,
      isShow,
      modalName,
      count,
    };
  },
});
pcHeader.use(pinia).mount('#app-mini-cart');

/**
 * 手機選單
 */

// eslint-disable-next-line vue/one-component-per-file
const mbSideBar = createApp({
  components: {
    BrandBtn,
    BrandList,
  },
  setup() {
    const { useMbMainSideBar, useMbSideBarClose } = useHeaderDiffer();

    const brandList = ref([]);
    function getBrandFollow() {
      getBrandFollowAPI()
        .then((res) => {
          if (res.data.Code === 200) {
            if (res.data.Response) {
              for (let i = 0; i < res.data.Response.length; i++) {
                if (res.data.Response[i].Followed) {
                  brandList.value.push(res.data.Response[i]);
                }
              }
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
    getBrandFollow();

    function updateBrandList() {
      brandList.value = [];
      getBrandFollow();
    }

    onMounted(() => {
      useMbMainSideBar();
      useMbSideBarClose();
    });

    return {
      brandList,
      updateBrandList,
    };
  },
});
mbSideBar.mount('#side-bar');

// eslint-disable-next-line vue/one-component-per-file
const mbBottomBar = createApp({
  setup() {
    const { useMbBottomBar } = useHeaderDiffer();
    const isLogin = ref(false);

    const miniCartStore = useMiniCartStore();
    const { totalCount } = storeToRefs(miniCartStore);
    function handleZeroQuantity() {
      alertDialog.alert('購物車目前無商品');
    }

    const isExpend = ref(false);
    function expendMenu() {
      isExpend.value = !isExpend.value;
    }

    onMounted(() => {
      isLogin.value = window.IsLogin === 'True';
      useMbBottomBar();
    });

    return { isLogin, totalCount, handleZeroQuantity, expendMenu, isExpend };
  },
});
mbBottomBar.mount('#bottom-bar');

/**
 * useGoToTop
 */
document.addEventListener('DOMContentLoaded', () => {
  const { scrollToTop, goToTopVisibility } = useGoToTop();
  window.addEventListener('scroll', () => goToTopVisibility('#top-btn', 500));
  scrollToTop('#top-btn', 250);
});

/**
 * useScrollBar TODO: 待測試
 */
document.addEventListener('DOMContentLoaded', () => {
  const { changeScrollbarPosition, customScrollbarX } = useScrollBar();
  // 所有文章頁 TabList X軸
  changeScrollbarPosition('.article-change-items', '.article-change-items .active');
  customScrollbarX('.article-change-items');
  // 所有會員頁 TabList X軸
  changeScrollbarPosition('.member-menu-list', '.member-menu-list .active');
  customScrollbarX('.member-menu-list');
});

// 全域方法前後端使用
window.messageBox = messageBox;
window.AlertDialog = alertDialog;

// TODO: GTM
$('.nav-name .banner a').on('click', function getBannerInfo(e) {
  window.localStorage.setItem(
    'promotion',
    JSON.stringify({
      clickName: 'Promotion Nav Banner',
      imgLink: $(this).children('img').attr('src'),
    }),
  );
});
